import React from "react";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";

export default function DeleteNotesConfirmationModal({
  open,
  onDelete,
  closeModal,
}) {
  return (
    <Modal isOpen={open}  className="single_grp_menu_leave_option dashboardArchiveModalContainer createModalContainer">
      <ModalHeader  className="dashboardHeader" toggle={closeModal}>Delete Attachment</ModalHeader>

      <ModalBody className="py-5 px-3 dashboardModalBody archiveDashboardModalContent">
        <span>Are you sure you want to remove this attachment?</span>


        <div
                    className="submitPrivacyContainer archiveBtnContainer"
                    style={{ padding: "10px 0px 0px 0px" }}
                  >
                    <Button
                      className={`archiveDashboardModalBtn`}
                      onClick={onDelete}
                    >
                      <span className="">
                        Delete
                        {/* <span className="ml10 flaticon-trash"></span> */}
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="14"
                          height="14"
                          fill="currentColor"
                          className=""
                          viewBox="0 0 16 16"
                        >
                          <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                          <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z" />
                        </svg>
                      </span>
                    </Button>

                    <Button
                      outline
                      color="secondary"
                      className="cancelDashboardModalBtn"
                      onClick={closeModal}
                    >
                      <span className="">Cancel</span>
                    </Button>
                  </div>
      </ModalBody>

      
    </Modal>
  );
}
